/**
 * KAN-997: подтверждение снятия пометки "Был под флудом" с аккаунта
 * (только суперпользователь). После снятия пул и кабинеты перезапрашиваются.
 */
import { toast } from 'sonner';
import { ConfirmDialog } from '@/components/telegram/ConfirmDialog';
import { useClearTgFloodMarks } from '@/hooks/usePlatform';
import { extractErrorMessage } from '@/lib/extractErrorMessage';
import { accountTitle } from '@/lib/platform';
import { clearFloodOutcome } from '@/lib/telegramFlood';
import type { TgPoolAccount } from '@/services/api/platform';

const VIEW = {
  title: 'Снять пометку "Был под флудом"?',
  description: 'Пометка снимется, история эпизодов (даты, число) сохранится.',
  confirm: 'Снять пометку',
};

interface ClearFloodDialogProps {
  account: TgPoolAccount | null;
  onClose: () => void;
}

export function ClearFloodDialog({ account, onClose }: ClearFloodDialogProps) {
  const mutation = useClearTgFloodMarks();

  const confirm = () => {
    if (!account) return;
    mutation.mutate([account.account_id], {
      onSuccess: (response) => {
        const outcome = clearFloodOutcome(response.results);
        if (outcome.ok) toast.success(outcome.text);
        else toast.error(outcome.text);
      },
      onError: (err) => toast.error(extractErrorMessage(err, 'Не удалось снять пометку')),
    });
    onClose();
  };

  return (
    <ConfirmDialog
      open={account !== null}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
      view={VIEW}
      onConfirm={confirm}
      testId="platform-clear-flood-dialog"
      extra={account ? `${accountTitle(account)}.` : null}
    />
  );
}
